import React, {useState} from "react";
import ListItem from "@material-ui/core/ListItem";
import FolderIcon from "@material-ui/icons/Folder";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import {AssetItem} from "./asset";
import {useSelector, useDispatch} from 'react-redux';
import {DenseIcon} from '../dense-icon';
import {Menu, MenuItem, Typography} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {TextDialog} from "../dialogs";
import {deleteAssets} from '../redux/assets-slice';
import {deleteFolder, renameFolder} from '../redux/folders-slice';
import { isStaticSite } from "../electron-modules";
import { Viewer } from "../viewer/js/main";


const initialState = {
  mouseX: null,
  mouseY: null,
};

export function AssetFolder(props) {
  const viewer = props.viewer as Viewer;
  const {folderID, handleAssetMove, name} = props;

  const dispatch = useDispatch();
  const assets = useSelector(state => state.assets.filter(asset => asset.folderID === folderID));
  const [open, setOpen] = useState(true);
  const [dragDropHover, setDragDropHover] = useState(false);
  const [renameOpen, setRenameOpen] = useState(false);
  const [menuState, setMenuState] = useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragDropHover(true);
  };

  const handleDragLeave = () => {
    setDragDropHover(false);
  };

  const handleDrop = (event) => {
    const assetID = event.dataTransfer.getData('text/plain');
    setDragDropHover(false);
    handleAssetMove(assetID, folderID);
  };

  const handleMenuClose = () => {
    setMenuState(initialState);
  };

  const handleRenameCancel = () => {
    setRenameOpen(false);
  };

  const handleRenameSubmit = name => {
    dispatch(renameFolder({id: folderID, name}));
    setRenameOpen(false);
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setMenuState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleDeleteClick = () => {
    dispatch(deleteAssets(folderID));
    dispatch(deleteFolder(folderID));
  };

  const handleRenameClick = () => {
    setMenuState(initialState);
    setRenameOpen(true);
  };

  const menuOpen = (menuState.mouseY !== null) && !isStaticSite;
  const anchorPosition = menuState.mouseY !== null && menuState.mouseX !== null
    ? { top: menuState.mouseY, left: menuState.mouseX }
    : undefined;

  return (
    <React.Fragment>
      <ListItem
        button
        onClick={handleClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onContextMenu={handleContextMenu}
        selected={dragDropHover}
      >
        <DenseIcon>
          <FolderIcon fontSize="small"/>
        </DenseIcon>
        <ListItemText primary={name}/>
        {assets.length > 0 && (open ? <ExpandLess/> : <ExpandMore/>)}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding dense={true}>
          {assets.map(asset => <AssetItem
            key={asset.id}
            assetID={asset.id}
            viewer={viewer}
          />)}
        </List>
      </Collapse>

      <Menu
        keepMounted
        open={menuOpen}
        onClose={handleMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
      >
        <MenuItem onClick={handleRenameClick}>
          <DenseIcon>
            <EditIcon fontSize="small"/>
          </DenseIcon>
          <Typography variant="inherit">Rename</Typography>
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <DenseIcon>
            <DeleteIcon fontSize="small"/>
          </DenseIcon>
          <Typography variant="inherit">Delete</Typography>
        </MenuItem>
      </Menu>

      <TextDialog
        open={renameOpen}
        onCancel={handleRenameCancel}
        onSubmit={handleRenameSubmit}
        title="Rename Folder"
        prompt="Enter new name"
        default={name}
        label="Folder Name"
      />
    </React.Fragment>
  );
}